module.exports = __webpack_public_path__ + "img/arrow-down-sort.svg";